module.exports = __webpack_public_path__ + "img/nbcb.a9f18bc1.jpg";